<template>
    <div class="shopping-cart-sum">
        <h2>Total</h2>
        <div class="shopping-cart-sum__list">
            <div class="shopping-cart-sum__list__values" v-if="priceOnce > 0">
                <div class="name">Einmalig zu zahlen</div>
                <div class="spacer"></div>
                <div class="value">{{ formatCurrency(priceOnce) }}</div>
            </div>
            <div class="shopping-cart-sum__list__values" v-if="pricePerMonth > 0">
                <div class="name">Monatlich zu zahlen</div>
                <div class="spacer"></div>
                <div class="value">{{ formatCurrency(pricePerMonth) }}</div>
            </div>
            <div class="shopping-cart-sum__list__values" v-if="pricePerYear > 0">
                <div class="name">Jährlich zu zahlen</div>
                <div class="spacer"></div>
                <div class="value">{{ formatCurrency(pricePerYear) }}</div>
            </div>
            <div class="shopping-cart-sum__list__values" v-if="pricePartial > 0">
                <div class="name">Teileinzug für 1. Mitspielmonat</div>
                <div class="spacer"></div>
                <div class="value">{{ formatCurrency(pricePartial) }}</div>
            </div>
        </div>
        <div class="shopping-cart-sum__button">
            <button @click.prevent="proceedToCheckout">Zur Kasse gehen</button>
        </div> 
    </div>
</template>

<script>
export default {
    props: {
        pricePartial: {
            type: Number,
            required: true
        },
        pricePerMonth: {
            type: Number,
            required: true
        },
        pricePerYear: {
            type: Number,
            required: true
        },
        priceOnce: {
            type: Number,
            required: true
        }
    },
    methods: {
        formatCurrency(price) {
            return price.toLocaleString('de-DE', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
            });
        },
        proceedToCheckout() {
            window.location.href = '/lotterie/checkout';
        },
    }
}
</script>
<style lang="scss" scoped>
.shopping-cart-sum {
    font-family: "Aktion Mensch Regular";
    background-color: var(--color-white);
    color: var(--color-text);
    margin-top: 2px;
    padding: 16px 32px 40px 32px;

    &__button {
        display: block;

        @media (min-width: 768px) and (max-width: 1379px) { 
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 32px;
        }
    }

    button{
        grid-column-start: 2; /* Starts in the 2nd column */
        grid-column-end: span 1; /* Spans across 1 column */

        font-family: "Aktion Mensch Bold";
        border: none;
        background-color: var(--color-red);
        color: var(--color-white);
        padding: 11px 16px;
        width: 100%;
        text-align: left;
        font-size: 16px;
        margin-top: 32px;
        cursor: pointer;
        position: relative;

        &:focus-visible {
            outline: 0.125rem solid #fff !important;
            outline-offset: 0.125rem;
            -webkit-box-shadow: 0 0 0 0.125rem #0060cc;
            box-shadow: 0 0 0 0.125rem #0060cc;
        }

        &:after {
            content: "";
            font-family: "icons-webfont";
            position: absolute;
            height: 30px;
            width: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            right: 9px;
            top: 7px;
        }
    }

    h2 {
        font-family: "Aktion Mensch Bold";
        font-size: 24px;
        color: var(--color-red);
        margin-bottom: 16px;
    }

    &__list {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 16px;

        &__values {
            display: grid;
            grid-template-columns: auto 1fr auto;
            grid-gap: 3px;

            .spacer {
                border-bottom: 1.5px dotted var(--border-color);
                margin-bottom: 2px;
            }

            .value{
                font-family: "Aktion Mensch Bold";
            }
        }
    }
}</style>
